import * as go from 'gojs';
import { getImageCrusherCH } from 'unitData/Crushers/CrusherConeCH/getImageCrusherCH';
import { getImageBinding, getIOPort, makeNode } from '../../utils';
import type { CrusherNodeData } from '../../../../types';

const alignInputPort = (node: CrusherNodeData): go.Spot => {
  if (node?.useHighBin) {
    return node.mirrored ? new go.Spot(5 / 8, 0) : new go.Spot(3 / 8, 0);
  } else {
    return go.Spot.Top;
  }
};

const alignOutputPort = (node: CrusherNodeData): go.Spot => {
  if (node?.useHighBin) {
    return node.mirrored ? new go.Spot(1 / 4, 1) : new go.Spot(3 / 4, 1);
  } else {
    return go.Spot.Bottom;
  }
};

export const CrusherCHTemplate = makeNode(
  getImageBinding('', (data: CrusherNodeData) =>
    getImageCrusherCH(
      data.showCustomModel ?? false,
      data.useHighBin ?? false,
      data.modelName,
    ),
  ),
  [getIOPort(alignInputPort, 'input'), getIOPort(alignOutputPort, 'output')],
);

export default CrusherCHTemplate;
